import { get, set, cloneDeep } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc WellViewAdministration defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { WellServeAdministration } from 'services/wellServeAdministration';
 *
 * // create service instance and send/cancel request
 * const wellServeAdministration = new WellServeAdministration();
 * const result = await wellServeAdministration.fetchData( '<user-id>' ); // fetch data
 * wellServeAdministration.cancel(); // cancel an active request
 */
export class WellServeAdministration extends HttpService {

    // make request and fetch data
    async fetchComponentData( { data = {}, url = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const title = get( response, 'body.component.structure.title', {} );
            const sections = get( response, 'body.component.structure.sections', {} );
            const primaryActions = get( response, 'body.component.structure.primaryActions', [] );
            const options = get( response, 'body.component.data.state.options', [] );

            for ( const sectionKey in sections ) {

                const _fields = cloneDeep( get( sections[ sectionKey ], 'fields', [] ) );

                _fields.forEach( _field => {

                    if ( _field.options ) {

                        _field.options = get( options, `${_field.options}`, [] );
                    }
                } );

                set( sections[ sectionKey ], 'fields', _fields );
            }
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title,
                    visibility,
                    sections,
                    primaryActions,
                    options
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data
    async submitData( { data = {}, url = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            if( SERVICE_RESPONSE_STATUS.FAILURE === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {

                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        title: get( response, 'body.component.data.description' )
                    }
                };
            }
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    title: get( response, 'body.component.data.description' )
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
